import { createStore } from 'zustand'

import { PriceIndexChartOptions, PriceIndexChartStore } from './interface'

export const createPriceIndexChartStore = ({
  priceIndexType
}: PriceIndexChartOptions) =>
  createStore<PriceIndexChartStore>((set, get) => ({
    priceIndexType,
    currentKind: undefined,
    setCurrentKind(currentKind) {
      set({ currentKind })
    },
    dateRange: undefined,
    setDateRange(dateRange) {
      set({
        dateRange
      })
    },
    chartType: 'line',
    setChartType(chartType) {
      set({
        chartType
      })
    }
  }))
